import classNames from "classnames";
import { FC, ReactNode } from "react";
import { useCollapse } from "react-collapsed";
import Icon from "~/components/Icon";
import Text from "~/components/Text";
import { isUsingLayoutV2 } from "~/utils/theme";

interface FilterItemProps {
  title?: string;
  children?: ReactNode;
}

const FilterItem: FC<FilterItemProps> = ({ title, children }) => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
    defaultExpanded: true,
  });

  return (
    <div
      className={classNames({
        "!min-w-[250px]": isUsingLayoutV2,
      })}
    >
      <div
        className="flex items-center gap-3 cursor-pointer select-none"
        {...getToggleProps()}
      >
        <Text
          className={classNames("flex-1 line-clamp-1", {
            uppercase: isUsingLayoutV2,
          })}
          type="label-3"
        >
          {title}
        </Text>
        <Icon name={isExpanded ? "arrow-square-up-2" : "arrow-square-down-2"} />
      </div>
      <section {...getCollapseProps()}>
        <div className="py-3">{children}</div>
      </section>
    </div>
  );
};

export default FilterItem;
